import React, { useEffect, useRef, useState } from 'react';
import { getPaidLeads } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import Input from '@/common/components/Input';
import {
	ChartWrapper,
	TitleSection,
	TopContentWrapper,
	Wrapper,
} from '../shared.styles';
import CustomLine from '@/common/charts/Line';

const PaidLeads = () => {
	const [chartData, setChartData] = useState();
	const {
		commonData: { products },
	} = useCommonDataContext();
	const timeRangeRef = useRef();

	const { makeRequest } = useRequestsContext();

	const handleLoadData = async () => {
		setChartData(() => null);
		const payload = {};
		payload.timeFrom = timeRangeRef.current.value;

		const response = await makeRequest(getPaidLeads.bind(null, payload));

		if (response?.data) {
			setChartData(() => response.data);
		}
	};

	useEffect(() => {
		if (products[0]) {
			handleLoadData();
		}
	}, [products]);

	return (
		<Wrapper width={800}>
			<TitleSection>
				<TopContentWrapper>
					<i className='fa fa-people-group' />
					Paid leads
				</TopContentWrapper>
				<TopContentWrapper>
					<Input
						showLabel={false}
						inputWidth={50}
						value={14}
						inputRef={timeRangeRef}
					/>
					<i
						class='fa-solid fa-arrows-rotate animation-scale'
						style={{ cursor: 'pointer' }}
						onClick={() => handleLoadData()}
					/>{' '}
				</TopContentWrapper>
			</TitleSection>
			<ChartWrapper>
				{chartData ? (
					<CustomLine data={chartData} />
				) : (
					<CustomSkeleton width={750} count={16} height={5} />
				)}
			</ChartWrapper>
		</Wrapper>
	);
};

export default PaidLeads;
